import styles from "./ListOfSlides.module.scss"

const ThumbsPagination = ({
  title,
  intro,
  media,
  poster,
  isMobile,
  isActive,
  duration = 0,
}) => {
  return (
    <div className={`${styles.thumb} ${isActive ? styles.active : ""}`}>
      {media && !isMobile && (
        <div className={styles.mediathumb}>
          {media.type === "video" && poster ? (
            <img
              src={poster.src}
              alt={poster.alt || media.alt || ""}
              className={styles.thumbImage}
            />
          ) : media.type === "image" ? (
            <img
              src={media.src}
              alt={media.alt || ""}
              className={styles.thumbImage}
            />
          ) : null}
        </div>
      )}
      <div className={styles.textThumb}>
        <div>
          {title && (
            <p className={styles.titleThumb}>
              <strong>{title}</strong>
            </p>
          )}
          {intro && (
            <div className={styles.description}>
              <p className="ellipsisStyle">{intro}</p>
            </div>
          )}
        </div>
        {media.type === "video" && isActive && duration > 0 && (
          <div className={styles.progressBar}>
            <div
              className={styles.progressIndicator}
              style={{ animationDuration: `${duration}s` }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ThumbsPagination
